import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1762856901181-27e955b87746?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZ2FyZGVuJTIwbGFuZHNjYXBpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc4MDg4NTQ0fDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="hero-section" className="relative min-h-[100vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Giardino curato"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-40 pb-24 md:pt-48 md:pb-32 min-h-[100vh] flex flex-col justify-center">
        <div className="max-w-3xl">
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.02] tracking-tight text-[#1A3628] mt-8 fade-up delay-1">
            L'arte del verde,
            <br />
            <span className="font-accent italic font-normal text-[#264F3B]">
              coltivata con cura.
            </span>
          </h1>

          <p className="mt-10 text-base md:text-lg max-w-xl text-[#2C3E50] leading-relaxed fade-up delay-2">
            Manutenzione, potatura, progettazione e cura di ogni dettaglio.
            Trasformo spazi verdi in luoghi vivi, equilibrati e duraturi.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-5 sm:items-center fade-up delay-3">
            <button
              data-testid="hero-cta-quote"
              onClick={() => scrollTo("contact")}
              className="btn-primary"
            >
              Contattami
              <ArrowDownRight size={16} strokeWidth={1.5} />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => scrollTo("services")}
              className="btn-ghost text-[#1A3628]"
            >
              Scopri i servizi →
            </button>
          </div>
        </div>

        <div className="hidden md:flex absolute bottom-10 right-12 items-end gap-6 fade-up delay-4">
          <div className="h-16 w-px bg-[#1A3628]/40" />
          <p className="overline text-[#1A3628]/80 max-w-[180px] leading-relaxed">
            Al servizio
            <br /> del paesaggio
          </p>
        </div>
      </div>
    </section>
  );
}
